SNI.Application.addModule('site-search-results', function(context) {

  return {
    behaviors: ['truncate']
  };

});
